import { getApiBase as getHttpClientBase } from './httpClient.js';

const DEFAULT_BASE = 'http://localhost:4100';

function resolveBase() {
  try {
    const candidate = (getHttpClientBase?.() || '').trim();
    if (candidate) return candidate.replace(/\/+$/, '');
  } catch {}

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }
  return DEFAULT_BASE;
}

const API_BASE = resolveBase();

export function getApiOrigin() {
  return API_BASE;
}

export function apiUrl(path = '') {
  const segment = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${segment}`;
}
